import { Box, Stack, StackProps, styled } from '@mui/material';

export const MoreArtworkButton = styled(({ children, ...props }: StackProps) => (
  <Stack alignItems="center" justifyContent="center" {...props}>
    {children}
  </Stack>
))(({ theme }) => ({
  cursor: 'pointer',
  marginLeft: '0.25rem',
  borderRadius: '60rem',
  fontSize: '0.625rem',
  fontWeight: 500,
  lineHeight: 'normal',
  color: 'white',
  padding: '0.25rem',
  aspectRatio: 1,
  backgroundColor: theme.palette.grey[800],
}));

export const NonImageFileThumbnail = styled(Box)({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  borderRadius: '4px',
  border: '1px solid #e0e0e0',
});

export const ArtworkThumbnail = styled('img')({
  cursor: 'pointer',
  width: '1.25rem',
  height: '1.25rem',
  objectFit: 'cover',
  borderRadius: '0.25rem',
  boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 5px 0px rgba(0, 0, 0, 0.06)',
  marginLeft: '-0.125rem',
  // Suppress alt-text rendering during the brief decode window between src
  // being set and the image painting. Screen readers still read `alt` because
  // they use the attribute directly, not rendered text.
  fontSize: 0,
  color: 'transparent',
});

ArtworkThumbnail.defaultProps = {
  decoding: 'async',
};
